import { createPinia } from 'pinia';
import { markRaw } from 'vue';
import type { Router } from 'vue-router';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

declare module 'pinia' {
  export interface PiniaCustomProperties {
    router: Router;
  }
}

export const createPiniaWithRouter = (router: Router) => {
  const pinia = createPinia();

  pinia.use(({ store }) => {
    store.router = markRaw(router);
  });

  if (!import.meta.env.SSR) {
    pinia.use(piniaPluginPersistedstate);
  }

  return pinia;
};
